import styled from 'styled-components'

export const FeaturedProductsWrapper = styled.div`
font-family: 'Noto Serif JP', serif;

`